if (!customElements.get('sz-card-cart')) {
  customElements.define(
    'sz-card-cart',
    class SzCardCart extends HTMLElement {
      constructor() {
        super();
        this.productId = parseInt(this.dataset.productId, 10);
        this.variantId = parseInt(this.dataset.variantId, 10);
        this.lineItemKey = null;
      }

      connectedCallback() {
        this.addPanel = this.querySelector('.sz-card-cart__add');
        this.qtyPanel = this.querySelector('.sz-card-cart__qty');
        this.qtyInput = this.querySelector('.sz-card-cart__quantity input');
        this.quantityInput = this.querySelector('quantity-input');
        this.spinner = this.querySelector('.sz-card-cart__spinner');

        this.addPanel?.addEventListener('click', (event) => event.stopPropagation());
        this.qtyPanel?.addEventListener('click', (event) => event.stopPropagation());

        this.onQuantityChange = (event) => {
          const qty = parseInt(event.target.value, 10);
          if (Number.isNaN(qty) || qty < 0) {
            this.syncFromCart();
            return;
          }
          this.setQuantity(qty);
        };

        this.qtyInput?.addEventListener('change', this.onQuantityChange);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'sz-card-cart') return;
          this.onCartUpdate(event);
        });

        if (this.qtyPanel?.hasAttribute('hidden')) {
          this.showAddPanel();
        }

        this.syncFromCart();
      }

      disconnectedCallback() {
        this.qtyInput?.removeEventListener('change', this.onQuantityChange);
        this.cartUpdateUnsubscriber?.();
      }

      onCartUpdate(event) {
        if (event.cartData?.items) {
          this.applyCartItems(event.cartData.items);
          return;
        }

        if (event.productVariantId || event.variantId) {
          this.syncFromCart();
        }
      }

      syncFromCart() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => this.applyCartItems(cart.items))
          .catch(() => {});
      }

      applyCartItems(items) {
        const productItems = items.filter((item) => item.product_id == this.productId);

        if (productItems.length === 0) {
          this.lineItemKey = null;
          this.showAddPanel();
          return;
        }

        const preferred =
          productItems.find((item) => item.variant_id == this.variantId) || productItems[0];

        this.variantId = preferred.variant_id;
        this.lineItemKey = preferred.key;
        this.dataset.variantId = String(this.variantId);
        this.showQtyPanel(preferred.quantity);
      }

      showAddPanel() {
        if (this.addPanel) this.addPanel.hidden = false;
        if (this.qtyPanel) this.qtyPanel.hidden = true;
      }

      showQtyPanel(quantity) {
        if (!quantity || quantity <= 0) {
          this.showAddPanel();
          return;
        }
        if (this.qtyInput) this.qtyInput.value = quantity;
        if (this.addPanel) this.addPanel.hidden = true;
        if (this.qtyPanel) this.qtyPanel.hidden = false;
        this.quantityInput?.validateQtyRules?.();
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
        if (this.qtyPanel) {
          this.qtyPanel.querySelectorAll('button, input').forEach((el) => {
            el.toggleAttribute('disabled', isLoading);
          });
        }
      }

      setQuantity(quantity) {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const nextQuantity = Math.max(0, quantity);

        const payload = {
          id: this.lineItemKey || this.variantId,
          quantity: nextQuantity,
        };

        if (cart?.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        this.setLoading(true);

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.syncFromCart();
              return;
            }

            if (response.items) {
              this.applyCartItems(response.items);
            } else {
              this.syncFromCart();
            }

            if (cart?.renderContents) {
              cart.renderContents(response);
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sz-card-cart',
              cartData: response,
              variantId: this.variantId,
            });
          })
          .catch(() => {
            this.syncFromCart();
          })
          .finally(() => {
            this.setLoading(false);
          });
      }
    }
  );
}
